// @flow

import * as React from "react";
import { Link } from "react-router-dom";

import type { ProjectType } from "../../data/projects";

import { withRetrieveProjects } from "../../data/projects";

import Page from "../../components/Page/Page";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";

// FIXME: Fix props types
const Inner = (props: Object) => {
  const projects: Array<ProjectType> = props.projectsData.allProjects;
  return (
    <ul>
      {projects.map(project => (
        <li key={project.id}>
          <Link to={`/projects/${project.id}`}>{project.name}</Link>
        </li>
      ))}
    </ul>
  );
};

const WrappedInner = withRetrieveProjects(WithLoadingIndicator(Inner));

const Projects = (props: Object) => (
  <Page className="Projects" title="Projects">
    <WrappedInner />
  </Page>
);

export default Projects;



// WEBPACK FOOTER //
// ./src/pages/Projects/Projects.js